import * as THREE from "three";
import Heatpoint from '../heatpointscontrol/heatpoint'
import gsap from "gsap";

export default class greenStreets extends THREE.Object3D {
	constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, greenstreet, model, visitedPinColor) {
		super();
	

		this.pinModel7 = new Heatpoint(null, "model/heatointstreet.glb")
        setTimeout(() => {
            this.pinModel7.setColor(pinColor);
        }, 1000);
		this.pinModel7.position.set(0.76, 0.40, -1.38);
        this.visited = false;
		interactionManager.add(this.pinModel7);

		this.pinModel7.addEventListener("click", (event) => {
			onPinClick();
			gsap.to(camera.position, { x: 1.3, y: 1.1, z: -2.6, duration: 2.5, ease: "Power3.inOut" })
            this.visited = true;  
            this.triggerAnimations(greenstreet,  model, true);
        })

		this.pinModel7.addEventListener('mouseover', (event) => {
			document.body.style.cursor = 'pointer';
            this.pinModel7.setColor(pinColorDark);
		});
		this.pinModel7.addEventListener('mouseout', (event) => {
			document.body.style.cursor = 'default';
            if(!this.visited){
                this.pinModel7.setColor(pinColor);
            }
            else{
				this.pinModel7.setColor(visitedPinColor);
			}
			
		});
		this.add(this.pinModel7)
		
		this.rotationAngle = 0;
    	this.rotatePin();
	}

    triggerAnimations(greenstreet, model, modal){
        const modal7 = document.getElementById('modal7');
        const overlay7 = document.getElementById('overlay7');
        setTimeout(() => {
     
            let tempMaterial =  new THREE.MeshStandardMaterial({ 
                map: greenstreet ,  
                emissive: 0x000000,
                emissiveIntensity: 1,     
                roughness: 1,
                metalness: 0,
            })
            tempMaterial.color.setHSL(0.3, 0.5, 0.5)

            function applyMaterial(target, material) {
                target.material = material;
                target.material.map.wrapS = THREE.RepeatWrapping;
                target.material.map.wrapT = THREE.RepeatWrapping;
                target.material.map.repeat.set(1, 1);
                target.material.needsUpdate = true;
            }
            
            // List of targets
            const targets = [
                model.children[0],
                model.children[1],
                model.children[3].children[1],
                model.children[41].children[1],
                model.children[43].children[1],
                model.children[53].children[1],
                model.children[57].children[1],
                model.children[19],
                model.children[20].children[4]
            ];
            
            // Apply material to each target
            targets.forEach(target => {
                if (target) applyMaterial(target, tempMaterial);
            });
            

            if(modal){
                setTimeout(() => {
                    modal7.classList.remove('hidden');
                }, 1000);
            }
        }, 3000);	

        overlay7.addEventListener('click', function() {

            const materialRoods = model.children[0].material
            materialRoods.map = null;
            materialRoods.metalnessMap = null;
            materialRoods.normalMap = null;
            materialRoods.roughnessMap = null;
            materialRoods.color.setHex(0x232323);
            materialRoods.needsUpdate = true;


            const materialbridge1 = model.children[1].material
            materialbridge1.map = null;
            materialbridge1.metalnessMap = null;
            materialbridge1.normalMap = null;
            materialbridge1.roughnessMap = null;
            materialbridge1.color.setHex(0x232323);
            materialbridge1.needsUpdate = true;

        })        
    }

    resetAnimations(model) {

        const materialRoods = model.children[0].material
        materialRoods.map = null;
        materialRoods.metalnessMap = null;
        materialRoods.normalMap = null;
        materialRoods.roughnessMap = null;
        materialRoods.color.setHex(0x232323);
        materialRoods.needsUpdate = true;


        const materialbridge1 = model.children[1].material
        materialbridge1.map = null;
        materialbridge1.metalnessMap = null;
        materialbridge1.normalMap = null;
        materialbridge1.roughnessMap = null;
        materialbridge1.color.setHex(0x232323);
        materialbridge1.needsUpdate = true;
        
        
        const materialRoods2 = model.children[0].material
        materialRoods2.map = null;
        materialRoods2.metalnessMap = null;
        materialRoods2.normalMap = null;
        materialRoods2.roughnessMap = null;
        materialRoods2.color.setHex(0x232323);
        materialRoods2.needsUpdate = true;
    }

	rotatePin() {
        this.rotationData = { angle: 0 };
        gsap.to(this.rotationData, {
            angle: "+=" + 2 * Math.PI, // Add 360 degrees in radians
            duration: 10, // Define how fast you want a full rotation to be. Here it's set to 5 seconds.
            ease: "none", // Linear rotation
            onUpdate: () => {
                this.pinModel7.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle);
            },
            repeat: -1 // This will make the animation run indefinitely
        });
	}
}